<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand" [routerLink]="'/'">
            <div class="brand-logo">
                <img class="img-responsive" src="assets/img/logo_step.png" alt="Step iDB Logo" />
            </div>
            <div class="brand-logo-collapsed">
                <img class="img-responsive" src="assets/img/logo_step.png" alt="Step iDB Logo" />
            </div>
        </a>
    </div>
    <!-- END navbar header-->

    <!-- START Nav wrapper-->
    <div class="nav-wrapper">
        <!-- START Left navbar-->
        <ul class="nav navbar-nav">
            <li>
                <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
                <a class="hidden-xs" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                    <em class="fa fa-navicon"></em>
                </a>
                <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
                <a class="visible-xs sidebar-toggle" (click)="settings.layout.asideToggled =! settings.layout.asideToggled">
                    <em class="fa fa-navicon"></em>
                </a>
            </li>
        </ul>
        <!-- END Left navbar-->

        <!-- START Right Navbar-->
        <ul class="nav navbar-nav navbar-right">

            <!-- Fullscreen (only desktops)-->
            <li class="visible-lg">
                <a #fsbutton (click)="toggleFullScreen($event)">
                    <em class="fa fa-expand"></em>
                </a>
            </li>


            <li>
                <a (click)="logout()" tooltip="Uitloggen">
                    <em class="icon-logout"></em>
                </a>
            </li>
            <!-- END Offsidebar menu-->
        </ul>
        <!-- END Right Navbar-->
    </div>
    <!-- END Nav wrapper-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
